import {fetchWithToken} from '@hublot-io/core-api/client'
import downloadjs from 'downloadjs'

import config from '../utils/apiUtils'

export const IntegrationService = {
  getIntegrations(context, clientid) {
    return fetchWithToken(
      `${config(context).integrationManagementService}/import/history/with-types/client/${clientid}`,
      {method: 'GET'}
    )
      .then(response => response.json())
      .then(json => json.data)
  },
  getAchats(date) {
    return fetchWithToken(`${config().venteService}/achats?date=${date}`, {method: 'GET'}).then(response =>
      response.json()
    )
  },
  downloadIntegration(context, idIntegration) {
    return fetchWithToken(`${config(context).erpImportService}/integration/file/${idIntegration}`, {method: 'GET'})
      .then(response => response.blob())
      .then(file => {
        downloadjs(file)
      })
  },
  postIntegration(context, file, date, serial) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('date', date)
    formData.append('serial', serial)

    return fetchWithToken(`${config(context).erpImportService}/integration`, {
      method: 'POST',
      body: formData
    }).then(response => response.text())
  },

  getPlu() {
    return fetchWithToken(`${config().erpSettings}/code`, {method: 'GET'}).then(response => response.json())
  },
  getServices(context, clientid) {
    return fetchWithToken(`${config(context).integrationManagementService}/import/registration/client/${clientid}`, {method: 'GET'})
      .then(response => response.json())
      .then(json => json.data)
  },
  refreshIntegration(idImport) {
    return fetchWithToken(`${config().erpSettings}/reload/${idImport}`, {method: 'POST'}).then(response =>
      response.json()
    )
  },
  manualIntegration(path, date) {
    return fetchWithToken(`https://api.hublot.io${path}/?date=${date}`, {method: 'POST'}).then(response =>
      response.text()
    )
  },
  insertCustomPlu(code) {
    return fetchWithToken(`${config().erpSettings}/code`, {
      method: 'POST',
      body: JSON.stringify(code)
    }).then(response => response.json())
  },
  getImportRules(context, idTypeImport) {
    const query = idTypeImport ? `?idTypeImport=${encodeURIComponent(idTypeImport)}` : ''
    return fetchWithToken(`${config(context).erpSettings}/rules${query}`, {method: 'GET'})
      .then(response => response.json())
      .then(json => (Array.isArray(json) ? json : (json.data || [])))
  },
  patchImportRuleCategory(context, idRule, category) {
    return fetchWithToken(`${config(context).erpSettings}/rules/${idRule}/category`, {
      method: 'PATCH',
      body: JSON.stringify({category})
    }).then(response => response.json())
  }
}
